var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 75C30.7174 75 21.815 71.3125 15.2513 64.7487C8.68749 58.185 5 49.2826 5 40C5 30.7174 8.68749 21.815 15.2513 15.2513C21.815 8.68749 30.7174 5 40 5C49.2826 5 58.185 8.68749 64.7487 15.2513C71.3125 21.815 75 30.7174 75 40C75 49.2826 71.3125 58.185 64.7487 64.7487C58.185 71.3125 49.2826 75 40 75ZM40 80C50.6087 80 60.7828 75.7857 68.2843 68.2843C75.7857 60.7828 80 50.6087 80 40C80 29.3913 75.7857 19.2172 68.2843 11.7157C60.7828 4.21427 50.6087 0 40 0C29.3913 0 19.2172 4.21427 11.7157 11.7157C4.21427 19.2172 0 29.3913 0 40C0 50.6087 4.21427 60.7828 11.7157 68.2843C19.2172 75.7857 29.3913 80 40 80Z",
    fill: "#18964E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8493 24.8514C54.8136 24.8859 54.7802 24.9227 54.7493 24.9614L37.3843 47.0864L26.9193 36.6164C26.2084 35.954 25.2681 35.5934 24.2966 35.6105C23.3251 35.6277 22.3982 36.0212 21.7111 36.7083C21.0241 37.3954 20.6305 38.3223 20.6134 39.2938C20.5962 40.2653 20.9569 41.2055 21.6193 41.9164L34.8493 55.1514C35.2057 55.5072 35.6301 55.7875 36.0972 55.9757C36.5643 56.1639 37.0645 56.256 37.568 56.2467C38.0715 56.2374 38.5679 56.1267 39.0277 55.9214C39.4875 55.716 39.9013 55.4201 40.2443 55.0514L60.2043 30.1014C60.8839 29.3881 61.2555 28.4359 61.2387 27.4507C61.2219 26.4656 60.8181 25.5266 60.1145 24.8369C59.411 24.1471 58.4642 23.7619 57.4789 23.7647C56.4936 23.7674 55.549 24.1578 54.8493 24.8514Z",
    fill: "#18964E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCircle);
export default __webpack_public_path__ + "static/media/success-circle.28c1cb97ca63ee7981f0846d05d3455a.svg";
export { ForwardRef as ReactComponent };